export default function replaceSpecialChar(string: string | null | undefined) {
  if (!string) return null;
  return string.replace(/[^a-zA-Z1-9]/g, "");
}
